import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Link, Stack, Alert, IconButton, InputAdornment } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useAlerts } from '../../../hooks/useAlerts'
import { loginSchema, loginInitialValues } from '../../../schemas/login.schema'
import { Iconify } from '../../../components/Iconify'
import FormProvider, { RHFTextField } from '../../../components/hook-form'
import { useAuthContext } from '../../../contexts/AuthContext'

const AuthLoginForm = () => {
  
  const { loginCtx } = useAuthContext()
  const { alertError } = useAlerts()

  const [showPassword, setShowPassword] = useState(false);

  const methods = useForm({
    resolver: yupResolver(loginSchema),
    defaultValues : loginInitialValues,
  })

  const {
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods

  const onSubmit = async (data) => {
    const ret = await loginCtx(data.email,data.password)
    if(ret?.code !== 200){
      alertError(ret?.msg || 'Credenciales inválidas.')
    }
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

        <RHFTextField name="email" label="Email" />

        <RHFTextField
          name="password"
          label="Contraseña"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack alignItems="flex-end" sx={{ my: 2 }}>
        <Link href='/auth/olvido_clave' variant="body2" color="inherit" underline="always">
          ¿Olvidaste tu contraseña?
        </Link>
      </Stack>

      <LoadingButton
        fullWidth
        color="inherit"
        size="large"
        type="submit"
        variant="contained"
        loading={isSubmitting}
        sx={{
          bgcolor: 'text.primary',
          color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          '&:hover': {
            bgcolor: 'text.primary',
            color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          },
        }}
      >
        Iniciar Sesión
      </LoadingButton>
    </FormProvider>
  )
}
export { AuthLoginForm }